const SSO_DOMAIN_DENY_PREFIX = "domain_requires_sso:";

export function parseSsoDomainDenyEmail(text: string): string | null {
  const match = text.match(/domain_requires_sso:([^\s]+)/i);
  const email = match?.[1]?.trim();
  if (!email || !email.includes("@")) {
    return null;
  }
  return email;
}

export function isSsoDomainDenyError(text: string): boolean {
  return text.toLowerCase().includes(SSO_DOMAIN_DENY_PREFIX);
}

export function isInvalidAuthStateError(message: string): boolean {
  return message.toLowerCase().includes("invalid state");
}
